import { useEffect, useState } from "react";

import { Login } from "../modules/apiUtils";

export default function TeamsIframeLogin({ match }) {
  const [error, setError] = useState(null);

  useEffect(() => {
    const loginWithTeamsId = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const msHomeAccountId =
          match?.params?.msHomeAccountId || params.get("msHomeAccountId");

        if (!msHomeAccountId) {
          throw new Error("Microsoft Teams account ID not found");
        }

        localStorage.setItem("msHomeAccountId", msHomeAccountId);
        sessionStorage.setItem("msHomeAccountId", msHomeAccountId);

        const loginResponse = await Login();
        if (!loginResponse || loginResponse.Data?.ResponseCode !== 200) {
          throw new Error("Unable to complete Ronspot login");
        }

        window.location.assign("/calendar");
      } catch (loginError) {
        console.error("Teams iframe login failed:", loginError);
        setError("Unable to complete Ronspot login");
      }
    };

    loginWithTeamsId();
  }, [match]);

  if (error) {
    return <div>{error}</div>;
  }

  return <div>Loading...</div>;
}
